import styled from 'styled-components';

export const Wrapper = styled.div`
  border-radius: 2px;

  overflow: hidden;
`;

export const Label = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.grey1100};
  margin-bottom: 24px;
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 16px;
    margin-bottom: 12px;
  }
`;

export const SummaryWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 24px;
  border: 1px solid ${({ theme }) => theme.palette.grey300};
  border-radius: 8px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`;

export const SummaryText = styled.div`
  width: 95%;
`;
export const LocationName = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.grey1100};
  margin-bottom: 3px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    font-size: 12px;
  }
`;
export const LocationAddress = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.grey600};
`;

export const MapWrapper = styled.div<{ fullScreen: boolean }>`
  width: 100%;
  position: relative;
  height: 433px;

  ${({ fullScreen }) =>
    fullScreen &&
    `
  width: 100vw;
  position: fixed;
  height: 100vh;
  z-index: 10000;
  top:0;
  left:0;
  `}

  & > div {
    position: relative;
    width: 100%;
    height: 100%;
    margin: 0;
    left: 0;
    top: 0;
    z-index: 2;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100vw;
    left: -15px;
  }
`;

export const IconWrapper = styled.div`
  margin-right: 24px;
  background-color: ${({ theme }) => theme.palette.grey100};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
